<template>
  <div id="pageAplicacion">
    <v-container grid-list-xl fluid>
      <div v-if="showAlert">
        <alert-empty></alert-empty>
      </div>
      <v-layout row wrap>
        <v-layout justify-center>
          <v-flex lg12>
            <v-layout>
              <v-flex>
                <!-- <div v-if="loading">
                <loading></loading>
                </div>-->
                <div>
                  <grafica-scan
                    v-for="(graf, indexChart) in pruebas"
                    :key="indexChart"
                    :res="res[indexChart]"
                    :titulo="titleGrafica[indexChart]"
                    :titleIn="titleTest[indexChart]"
                  ></grafica-scan>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import API from "@/api";
import Material from "vuetify/es5/util/colors";
import axios from "axios";
import { mapState } from "vuex";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  components: {
    Loading,
    AlertEmpty,
  },
  mixins: [misMixins],
  data: () => ({
    menu1: false,
    color: Material,
    selectedTab: "tab-1",
    indexChart: 0,
    res: [],
    titleGrafica: [],
    titleTest: [],
    pruebas: [],

    showAlert: false,
    loading: false,
  }),

  computed: {},
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.id = this.$route.params.id;
    this.filter();
  },
  mounted() {},
  methods: {
    filter() {
      this.loadData();
      //this.loadDataCaptura();
    },

    async loadData() {
      this.loading = true;
      this.pruebas = [];
      this.pruebas = await this.loadFilter();
      if (this.pruebas.length > 0) {
        this.pruebas.forEach((m) => {
          let data = [];
          this.titleTest[this.indexChart] = "Tipo Prueba: " + m.tipoPrueba;
          this.titleGrafica[this.indexChart] = "Nivel: " + m.s_nivel + "/ Scan";
          data.push(
            {
              name: "Escaneado: " + m.porc_escaneado.toFixed(2) + " %",
              value: m.porc_escaneado.toFixed(2),
            },
            {
              name: "Pendiente: " + m.porc_pendiente.toFixed(2) + " %",
              value: m.porc_pendiente.toFixed(2),
            }
          );

          this.res[this.indexChart] = data;
          this.indexChart += 1;
        });
      } else {
        this.showAlert = true;
      }
      this.loading = false;
    },
    async loadFilter() {
      return await axios
        .get("/captura/scan/grafica/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
